import axios from "axios";
import buildUrl from "build-url-ts";
import {
  GatingCatalogSearchRequest,
  GatingCatalogSearchResponse,
} from "src/types/experiences/storyboardSettings";

const BASE_URL = process.env.REACT_APP_CLEVERSTORY_API_URL;
const apiV2 = `${BASE_URL}/api/2.0`;

export const gatingApi = {
  searchGatingCatalog: async (
    request: GatingCatalogSearchRequest = {},
  ): Promise<GatingCatalogSearchResponse> => {
    const page = request.page ?? 0;
    const limit = request.limit ?? 50;
    const url = buildUrl(`${apiV2}/gating/search`, {
      queryParams: { page, limit },
    });

    const body: Record<string, unknown> = {};
    if (request.storyboard !== undefined) body.storyboard = request.storyboard;
    if (request.published !== undefined) body.published = request.published;
    if (request.progressive !== undefined) body.progressive = request.progressive;

    const response = await axios.post(url, body);
    return response.data;
  },
};
